import type { Template } from "@/types";

export const PO_07_H2_V5: Template[] = [
{
    id: "po-07-h2v5-01",
    name: "PO 01 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_01.png",
    size: [1136, 854],
    style: {},
        slots: [         
            { id: "1", x: 42, y: 237, width: 252, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 42, y: 432, width: 252, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 302, y: 237, width: 224, height: 381, rotation: 0, imageRotation: 0 },
            { id: "4", x: 657, y: 106, width: 192, height: 318, rotation: 0, imageRotation: 0 },
            { id: "5", x: 657, y: 432, width: 192, height: 317, rotation: 0, imageRotation: 0 },
            { id: "6", x: 857, y: 106, width: 191, height: 318, rotation: 0, imageRotation: 0 },
            { id: "7", x: 857, y: 432, width: 191, height: 317, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h2v5-02",
    name: "PO 02 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 42, y: 237, width: 252, height: 187, rotation: 0, imageRotation: 0 },
        { id: "2", x: 42, y: 432, width: 252, height: 186, rotation: 0, imageRotation: 0 },
        { id: "3", x: 302, y: 237, width: 224, height: 381, rotation: 0, imageRotation: 0 },
        { id: "4", x: 615, y: 160, width: 355, height: 534, rotation: 0, imageRotation: 0 },
        { id: "5", x: 978, y: 159, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "6", x: 978, y: 340, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "7", x: 978, y: 521, width: 107, height: 172, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-03",
    name: "PO 03 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 61, y: 160, width: 470, height: 280, rotation: 0, imageRotation: 0 },
        { id: "2", x: 61, y: 448, width: 318, height: 246, rotation: 0, imageRotation: 0 },
        { id: "3", x: 387, y: 448, width: 145, height: 246, rotation: 0, imageRotation: 0 },
        { id: "4", x: 615, y: 160, width: 355, height: 534, rotation: 0, imageRotation: 0 },
        { id: "5", x: 978, y: 159, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "6", x: 978, y: 340, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "7", x: 978, y: 521, width: 107, height: 172, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-04",
    name: "PO 04 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 61, y: 160, width: 359, height: 264, rotation: 0, imageRotation: 0 },
        { id: "2", x: 61, y: 432, width: 359, height: 263, rotation: 0, imageRotation: 0 },
        { id: "3", x: 428, y: 160, width: 103, height: 173, rotation: 0, imageRotation: 0 },
        { id: "4", x: 428, y: 341, width: 103, height: 173, rotation: 0, imageRotation: 0 },
        { id: "5", x: 428, y: 522, width: 103, height: 172, rotation: 0, imageRotation: 0 },
        { id: "6", x: 617, y: 226, width: 231, height: 404, rotation: 0, imageRotation: 0 },
        { id: "7", x: 856, y: 226, width: 231, height: 404, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-05",
    name: "PO 05 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 50, y: 224, width: 240, height: 408, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 298, y: 224, width: 222, height: 200, rotation: 0, imageRotation: 0 },
        { id: "3", x: 298, y: 432, width: 222, height: 200, rotation: 0, imageRotation: 0 },
        { id: "4", x: 615, y: 160, width: 355, height: 534, rotation: 0, imageRotation: 0 },
        { id: "5", x: 978, y: 160, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "6", x: 978, y: 341, width: 107, height: 173, rotation: 0, imageRotation: 0 },
        { id: "7", x: 978, y: 522, width: 107, height: 172, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-06",
    name: "PO 06 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_06.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 82, y: 167, width: 146, height: 257, rotation: 0, imageRotation: 0 },
        { id: "2", x: 82, y: 432, width: 146, height: 256, rotation: 0, imageRotation: 0 },
        { id: "3", x: 236, y: 167, width: 146, height: 257, rotation: 0, imageRotation: 0 },
        { id: "4", x: 236, y: 432, width: 146, height: 256, rotation: 0, imageRotation: 0 },
        { id: "5", x: 390, y: 167, width: 309, height: 521, rotation: 0, imageRotation: 0 },
        { id: "6", x: 707, y: 167, width: 347, height: 257, rotation: 0, imageRotation: 0 },
        { id: "7", x: 707, y: 432, width: 347, height: 256, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-07",
    name: "PO 07 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 82, y: 167, width: 146, height: 257, rotation: 0, imageRotation: 0 },
        { id: "2", x: 236, y: 167, width: 146, height: 257, rotation: 0, imageRotation: 0 },
        { id: "3", x: 390, y: 167, width: 344, height: 257, rotation: 0, imageRotation: 0 },   
        { id: "4", x: 82, y: 432, width: 344, height: 256, rotation: 0, imageRotation: 0 },      
        { id: "5", x: 434, y: 432, width: 146, height: 256, rotation: 0, imageRotation: 0 },
        { id: "6", x: 588, y: 432, width: 146, height: 256, rotation: 0, imageRotation: 0 },
        { id: "7", x: 742, y: 167, width: 312, height: 521, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-07-h2v5-08",
    name: "PO 08 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 276, width: 173, height: 302, rotation: 0, imageRotation: 0 },
        { id: "2", x: 181, y: 276, width: 172, height: 302, rotation: 0, imageRotation: 0 },
        { id: "3", x: 361, y: 276, width: 412, height: 302, rotation: 0, imageRotation: 0 },
        { id: "4", x: 781, y: 276, width: 173, height: 302, rotation: 0, imageRotation: 0 },
        { id: "5", x: 962, y: 276, width: 174, height: 147, rotation: 0, imageRotation: 0 },      
        { id: "6", x: 962, y: 431, width: 83, height: 147, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1053, y: 431, width: 83, height: 147, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-09",
    name: "PO 09 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_09.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 82, y: 167, width: 146, height: 257, rotation: 0, imageRotation: 0 },
        { id: "2", x: 82, y: 432, width: 146, height: 256, rotation: 0, imageRotation: 0 },
        { id: "3", x: 236, y: 167, width: 146, height: 257, rotation: 0, imageRotation: 0 },
        { id: "4", x: 236, y: 432, width: 146, height: 256, rotation: 0, imageRotation: 0 },
        { id: "5", x: 390, y: 167, width: 345, height: 257, rotation: 0, imageRotation: 0 },
        { id: "6", x: 390, y: 432, width: 345, height: 256, rotation: 0, imageRotation: 0 },
        { id: "7", x: 743, y: 167, width: 313, height: 521, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h2v5-10",
    name: "PO 10 - H2V5",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h2_v5_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 71, y: 0, width: 562, height: 423, rotation: 0, imageRotation: 0 },
        { id: "2", x: 71, y: 431, width: 562, height: 423, rotation: 0, imageRotation: 0 },
        { id: "3", x: 641, y: 0, width: 173, height: 280, rotation: 0, imageRotation: 0 },
        { id: "4", x: 641, y: 288, width: 173, height: 279, rotation: 0, imageRotation: 0 },
        { id: "5", x: 641, y: 575, width: 173, height: 279, rotation: 0, imageRotation: 0 },
        { id: "6", x: 822, y: 0, width: 243, height: 424, rotation: 0, imageRotation: 0 },
        { id: "7", x: 822, y: 432, width: 243, height: 423, rotation: 0, imageRotation: 0 }
    ],
}
];